import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/apps/id/page';

export const Route = createFileRoute('/_app/_chat/apps/$id/')({
  component: Page,
});
